import { Card, CardBody, CardHeader } from '@heroui/react';
import { useTranslation } from 'react-i18next';

export function EndCard({ headerText }: { headerText: string }) {
  const { t } = useTranslation('home');

  return (
    <Card shadow="none" className="bg-transparent px-0">
      <CardHeader className="px-0">
        <h1 className="text-2xl">{headerText}</h1>
      </CardHeader>
      <CardBody className="px-0">
        <h2>{t('endcard.title')}</h2>
        <p className="font-light">{t('endcard.description')}</p>
      </CardBody>
    </Card>
  );
}
